import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { FitmentsTableComponent } from 'shared/fitments/fitments-table/fitments-table.component';
import * as utils from 'utils/utils';
import { segmentsData } from '../../../product-details/segments-data-stub';
import { advancedSearchRouteMap } from 'shared/search/search-helpers';
import { UserService } from 'shared/user/user.service';
import { indexPagesData } from 'utils/index-pages-data';

import { ScrollToService } from 'shared/base/scroll-to.service';
import {first} from 'rxjs/operators';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-fitment',
  templateUrl: 'fitment.component.html',
  styleUrls: ['fitment.component.scss'],
  providers: [ScrollToService],
})
export class FitmentComponent extends BaseSegmentComponent implements OnInit {

  data: any = segmentsData.fitments;
  advancedSearchStatus: string;
  ghostValue: string = 'ecomm-08';
  // to hide search input if there no fitments at the beginning
  hasSearch: boolean = true;

  @ViewChild(FitmentsTableComponent, {static: true})
  fitmentsTable: FitmentsTableComponent | void;

  constructor(
    private scrollToService: ScrollToService,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.advancedSearchStatus = advancedSearchRouteMap[this.getRoute()];
    if (this.fitmentsTable) {
      this.fitmentsTable.dataFetched
        .pipe(first())
        .subscribe((data: any) => {
          // if there is no data at the beginning then hide advanced search
          if (!data || !data.data.length) {
            this.hasSearch = false;
            this.ref.markForCheck();
          }
        });
    }
  }

  private getRoute() {
      return _.head( _.keys(
        _.pickBy(indexPagesData, (value, key) => {
          return value.itemStatuses.indexOf(this.itemDetail.status) > -1;
        })
      ));
  }
}
